import { HttpInterceptorFn } from '@angular/common/http';
import { retry, timer } from 'rxjs';

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  // Only retry GET requests
  if (req.method !== 'GET') {
    return next(req);
  }

  return next(req).pipe(
    retry({
      count: 3,
      delay: (error, retryCount) => {
        // Don't retry on authentication errors (401) or client errors (4xx)
        if (
          error.status === 401 ||
          error.status === 403 ||
          (error.status >= 400 && error.status < 500)
        ) {
          throw error; // Stop retrying
        }

        // Exponential backoff: 1s, 2s, 4s
        const delayMs = Math.pow(2, retryCount - 1) * 1000;
        return timer(delayMs);
      },
      resetOnSuccess: true,
    })
  );
};
